import module from "./vuex-identity-store";

// initialize the plugin object
let VuexIdentityPlugin = {};

// internationalization plugin for vue js using vuex
VuexIdentityPlugin.install = function install(Vue, store, config) {
  // merge default options with user supplied options
  let mergedConfig = Object.assign(
    {
      moduleName: "identity"
    },
    config
  );

  // define module name and identifiers as constants to prevent any changes
  const moduleName = mergedConfig.moduleName;
  //const identifiers = mergedConfig.identifiers;

  // register the module in the vuex store
  store.registerModule(moduleName, module);

  // check if the plugin was correctly initialized
  if (store.state.hasOwnProperty(moduleName) === false) {
    console.error(
      "Identity vuex module is not correctly initialized. Please check the module name:",
      moduleName
    );

    // always return the key if module is not initialized correctly
    Vue.prototype.$identity = function(key) {
      return key;
    };

    return;
  }

  const clearAll = function clearAll() {
    return store.dispatch({
      type: "clearAll"
    });
  };

  const getToken = function getToken(username, password) {
    var auth = btoa(username + ":" + password);
    return store.dispatch({
      type: "getToken",
      auth: auth
    });
  };

  const setSeasons = function setSeasons(lang) {
    store.dispatch({
      type: "setSeasons",
      lang: lang
    });

    return store.state[moduleName].seasons;
  };

  const getSeasons = function getSeasons() {
    return store.state[moduleName].seasons;
  };

  const getUserName = function getUserName() {
    var userinfo = store.state[moduleName].userInfo;

    if (userinfo == null) {
      return "user";
    }

    if (isArray(userinfo.roles) && userinfo.roles.includes("SuperAdmin")) {
      return "Volcan";
    }

    return userinfo.name;
  };

  const getUserId = function getUserId() {
    var userinfo = store.state[moduleName].userInfo;

    if (userinfo == null) {
      return "user";
    }

    if (isArray(userinfo.roles) && userinfo.roles.includes("SuperAdmin")) {
      return "Volcan";
    }
    return userinfo.oasisId;
  };

  const getUserRoles = function getUserRoles() {
    var userinfo = store.state[moduleName].userInfo;
    if (userinfo == null) {
      return [];
    }

    if (isArray(userinfo.roles)) {
      return userinfo.roles.map(function(value) {
        return value.toLowerCase();
      });
    }

    return [];
  };

  const existUserInfo = function existUserInfo() {
    return store.state[moduleName].userInfo != null;
  };

  const existRoles = function existRoles() {
    return store.state[moduleName].roles != null;
  };

  const roles = Object.freeze({
    superadmin: "superadmin",
    admin: "admin",
    trustedEmploye: "trustedemploye",
    employe: "employe",
    inventory: "inventory",
    supplier: "supplier",
    salesman: "salesman",
    customer: "customer"
  });

  const validedToken = function validedToken(to, lang) {
    return store.dispatch({
      type: "valideToken",
      to: to,
      lang: lang
    });
  };

  const getSeasonName = function getSeasonName(seasonId) {
    var seasons = store.state[moduleName].seasons;
    if (seasons.length > 0) {
      var seasonFinded = seasons.filter(function(season) {
        return season.id === seasonId;
      });
      if (seasonFinded.length > 0) {
        return seasonFinded[0].name;
      }
    }
    return seasonId;
  };

  const getGoogleDriveLink = function getGoogleDriveLink() {
    var userinfo = store.state[moduleName].userInfo;

    if (userinfo == null) {
      return "user";
    }

    if (isArray(userinfo.roles) && userinfo.roles.includes("SuperAdmin")) {
      return "Volcan";
    }

    return userinfo.name;
  };

  // register vue prototype methods
  Vue.prototype.$identity = {
    getToken: getToken,
    getUserName: getUserName,
    getUserId: getUserId,
    getUserRoles: getUserRoles,
    roles: roles,
    rolesPublic: spliceRoles(roles),
    clearAll: clearAll,
    setSeasons: setSeasons,
    getSeasons: getSeasons,
    getSeasonName: getSeasonName,
    getGoogleDriveLink: getGoogleDriveLink
  };

  // register global methods
  Vue.identity = {
    getToken: getToken,
    existUserInfo: existUserInfo,
    validedToken: validedToken,
    existRoles: existRoles,
    getUserName: getUserName,
    getUserId: getUserId,
    getUserRoles: getUserRoles,
    roles: roles,
    publicRoles: spliceRoles(roles),
    clearAll: clearAll,
    setSeasons: setSeasons,
    getSeasons: getSeasons,
    getSeasonName: getSeasonName,
    getGoogleDriveLink: getGoogleDriveLink
  };
};

// check if the given object is an array
function isArray(obj) {
  return !!obj && Array === obj.constructor;
}

function spliceRoles(roles) {
  var rolesSpliced = [];
  Object.getOwnPropertyNames(roles).forEach(function(roleName) {
    if (roleName !== "superadmin") {
      rolesSpliced.push(roles[roleName]);
    }
  });

  return rolesSpliced;
}

export default VuexIdentityPlugin;



// WEBPACK FOOTER //
// ./src/identity/vuex-identity-plugin.js